import React from "react";
import loginImg from "../../Assets/Login/login_page.gif";
import { FaEnvelope, FaLock } from "react-icons/fa";
import logo from "../../Assets/Logos/Logo.png";

const Login = () => {
  return (
    <div className="h-screen flex items-center justify-center bg-gradient-to-r from-[#305977] to-[#2d7ac7] px-4 sm:px-8 md:px-16 lg:px-24 xl:px-32 py-10">
      <div className="bg-white rounded-xl w-full grid grid-cols-1 md:grid-cols-2">
        <div className="flex items-center justify-center">
          <div className="w-full px-6 sm:px-10 md:px-20  bg-white rounded-xl">
            <div className="flex justify-center mb-8">
              <img src={logo} alt="logo" className="w-28 h-28" />
            </div>
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-10 text-center">
              Member Login
            </h2>
            <form className="space-y-8">
              <div className="relative">
                <FaEnvelope className="absolute left-3 top-3 text-gray-400" />
                <input
                  type="email"
                  placeholder="Email"
                  required
                  className="w-full pl-10 pr-4 py-2 rounded-md border border-gray-300"
                />
              </div>

              <div className="relative">
                <FaLock className="absolute left-3 top-3 text-gray-400" />
                <input
                  type="password"
                  placeholder="Password"
                  required
                  className="w-full pl-10 pr-4 py-2 rounded-md border border-gray-300"
                />
              </div>

              <div className="flex justify-center">
                <button
                  type="submit"
                  className="w-1/2 bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] text-white tracking-wide font-medium py-2 md:py-3 rounded-lg text-sm md:text-base shadow-md hover:shadow-lg transition-all duration-300"
                >
                  Submit
                </button>
              </div>

              <div className="text-center text-sm text-gray-500 mt-2">
                <p className="hover:underline cursor-pointer" onClick="#">
                  {" "}
                  Forgot Your Password?
                </p>
              </div>
            </form>
          </div>
        </div>

        <div className="col-span-1 w-full h-auto hidden md:block ">
          <img
            src={loginImg}
            alt=""
            className="w-full h-auto object-cover rounded-r-xl"
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
